type FolderId = string | null;

export type Folder = {
  id: FolderId;
  parentFolderId: FolderId;
  title: string;
  subfolders?: Folder[];
};

export type FolderAbilities = {
  create: boolean;
  move: boolean;
  duplicate: boolean;
  rename: boolean;
  delete: boolean;
};

export type FolderPayload = Omit<Folder, 'id' | 'subfolders'>;

export type Item = Omit<Folder, 'subfolders'>;

export type FoldersListSorting = {
  direction: SortingDirection;
  option: SortingOption;
};

export enum SortingDirection {
  asc = 'asc',
  desc = 'desc'
}

export enum SortingOption {
  Alphabetical = 'Alphabetical',
  Created = 'Created',
  Edited = 'Edited'
}

/**
 * The purpose of StrictUnionHelper is to ensure that each member of the union T is treated strictly,
 * meaning that it cannot have properties that are not defined in its own type.
 * By using Partial<Record<...>>, it ensures that any extra properties from other union members are set to never, making them invalid.
 * This utility is useful when you want to enforce strict type checking on union types,
 * ensuring that each member of the union is distinct and does not accidentally include properties from other members.
 */
type UnionKeys<T> = T extends T ? keyof T : never;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type StrictUnionHelper<T, TAll> = T extends any ? T & Partial<Record<Exclude<UnionKeys<TAll>, keyof T>, never>> : never;

export type StrictUnion<T> = StrictUnionHelper<T, T>;
